import React, { useContext, useState } from 'react';
import styled from 'styled-components';

import AppContext from '../context/AppContext';
import Modal from './Modal';

import { User } from './index';

import defPic from '../assets/images/bg.jpg';
const FollowModal = ({ show, onClose, users, title }) => {
  const { theme } = useContext(AppContext);

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={title}
      modalStyle={{ height: 'auto' }}
    >
      <StyledFollowModal theme_={theme}>
        <div className="users">
          {users?.map((user, index) => (
            <User
              user={
                title == 'Followers'
                  ? user?.wallet?.defaultProfile
                  : user?.profile
              }
              key={index}
            />
          ))}
        </div>
      </StyledFollowModal>
    </Modal>
  );
};
const StyledFollowModal = styled.div`
  padding: 2rem 0rem;
  display: flex;
  flex-direction: column;
  gap: 0rem;
  -moz-box-shadow: 0 0 3px #ccc;
  -webkit-box-shadow: 0 0 3px #ccc;
  box-shadow: 0 0 3px #ccc;
  height: 30rem;
  margin-top: 1rem;
  overflow-y: scroll;
  overflow-x: hidden;
  .users {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    border-radius: 0.5rem;
    @media screen and (max-width: 900px) {
      gap: 0rem;
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  padding: 1rem;
`;

export default FollowModal;
